function getComp(name) {
  return import(
    `./${name}.vue`
  );
}

export const route = {
  path: '/approvedByMeList',
  name: 'approvedByMeList',
  component: getComp.bind(null, 'ApprovedByMeList'),
  meta: {
    matchNav: 'approvedByMeList',
  },
};